import ModalDialog from "Components/ModalDialog";
import React, { FunctionComponent} from "react";
import { useSelector } from "react-redux";
import {
  ModalHeader,
  ModalBody,
  ModalBodyContainer,
  TabPanel,
  ModalFooter,
} from "./styled.components";
import Buttons from "../Buttons";
import Spinner from "../Spinner";
import { Icon, Tab, Tabs } from "@mui/material";

type TabsModalProps = {
  open: boolean;
  tabs: any;
  selectedTab: number;
  lastTab: number;
  children?: any;
  fullWidth?: boolean;
  modalSize?: string;
  isLoading?: boolean;
  handleTabChangeClick: (event: any, newTab: any) => void;
  handleNextClick: () => void;
  handleAcceptClick: () => void;
  handleCancelClick: () => void;
  minH?: any;
  maxH?: any;
  action?: number;
};

const TabsModal: FunctionComponent<TabsModalProps> = ({
  open,
  tabs,
  selectedTab,
  lastTab,
  children,
  fullWidth = true,
  modalSize,
  isLoading = false,
  handleNextClick,
  handleTabChangeClick,
  handleAcceptClick,
  handleCancelClick,
  minH,
  maxH,
  action = 0,
}) => {
  const { bannerTabsModal } = useSelector((state: any) => state.theme);
  const { btnSimple } = useSelector((state: any) => state.theme);
  const { catalogs, themeTabs } = useSelector((state: any) => state.theme);

  const getColorTabs = (_myTheme: any): string => {
    if (!_myTheme) return "#0009";
    if (!_myTheme.textColor) return "#0009";
    return _myTheme.textColor;
  };

  const getColorTabsIndicator = (_myTheme: any): string => {
    if (!_myTheme) return "rgba(156,39,176,1)";
    if (!_myTheme.indicatorColor) return "rgba(156,39,176,1)";
    return _myTheme.indicatorColor;
  };
  const handleRenderTabs = (tab: any) => {
    return (
      <Tab
        id={`simple-tab-${tab.id}`}
        key={`simple-tab-${tab.id}`}
        label={tab.name}
        sx={{
          color: 'white', 
          '& .MuiTab-label': {
            color: 'red', // Cambia el color del texto de la pestaña a blanco
          },
          '&.Mui-selected': {
            color: '#000',
          }
        }}
        aria-controls={`simple-tabpanel-${tab.id}`}
        style={{
          color: getColorTabs(themeTabs),
        }}
      />
    );
  };

  const renderBtnCancel = () => {
    return (
      <Buttons
        title={"Cancelar"}
        type={"cancel-catalog"}
        config={btnSimple}
        visible={true}
        handleClick={handleCancelClick}
      />
    );
  };

  const renderBtnAction = () => {
    if (lastTab !== selectedTab) {
      return (
        <Buttons
          title={""}
          type={"plus-catalog"}
          config={btnSimple}
          visible={true}
          handleClick={handleNextClick}
        >
          <Icon>arrow_forward</Icon>
        </Buttons>
      );
    }

    if (action === 0) {
      return (
        <Buttons
          title={"Guardar"}
          type={"accept-catalog"}
          config={btnSimple}
          visible={true}
          handleClick={handleAcceptClick}
        />
      );
    }
  };

  return (
    <div>
      <ModalDialog
        open={open}
        modalSize={modalSize}
        background={catalogs.backgroundItem}
      >
        <>
          <ModalHeader
            bgImagen={
              bannerTabsModal
                ? `${process.env.PUBLIC_URL}${bannerTabsModal}`
                : "/commons/layer-header-@2x.png)"
            }
          >
            <Tabs
              value={selectedTab}
              onChange={handleTabChangeClick}
              centered
              variant={fullWidth ? "fullWidth" : undefined}
              textColor={"secondary"}
              indicatorColor={"secondary"}
              style={{ width: "100%", fontWeight: 600 }}
              TabIndicatorProps={{
                style: { backgroundColor: getColorTabsIndicator(themeTabs) },
              }} // Set custom color here
            >
              {tabs.map(handleRenderTabs)}
            </Tabs>
          </ModalHeader>
          <ModalBody>
            <ModalBodyContainer minH={minH} maxH={maxH}>
              {children}
            </ModalBodyContainer>
            <ModalFooter>
              {isLoading ? (
                <Spinner />
              ) : (
                <>
                  {renderBtnCancel()}
                  {renderBtnAction()}
                </>
              )}
            </ModalFooter>
          </ModalBody>
        </>
      </ModalDialog>
    </div>
  );
};

type TabModalPanelProps = {
  tabId: number;
  selectedTab: number;
  children?: any;
  minH?: any;
};

export const TabModalPanel: FunctionComponent<TabModalPanelProps> = ({
  tabId,
  selectedTab,
  children,
}) => {
  return (
    <TabPanel
      role="tabpanel"
      hidden={selectedTab !== tabId}
      id={`simple-tabpanel-${tabId}`}
      aria-labelledby={`simple-tab-${tabId}`}
    >
      {children}
    </TabPanel>
  );
};

export default TabsModal;
